// extracted by css-extract-rspack-plugin
export default {"root":"S3KiAw"};